import { BrowserRouting } from '@aipb/gulliver/browser/routing';
import { CatalogEnvService } from '@aipb/gulliver/catalog/env';
import { CustomRecordItem } from '@aipb/gulliver/catalog/model';
import { createDetailCompositeKey, isDropbox } from '@aipb/gulliver/catalog/util';
import { EnvService } from '@aipb/gulliver/env/util';
import { openUrl } from '@aipb/shared/util/routing';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { ImagePreviewDialogService } from '../../dialogs';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'cat-image-preview-button',
  templateUrl: './image-preview-button.component.html',
  styleUrls: ['./image-preview-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslocoModule]
})
export class ImagePreviewButtonComponent {
  @Input() coreId: string;

  private env = inject(EnvService);
  private catalogEnv = inject(CatalogEnvService);
  private transloco = inject(TranslocoService);
  private browserRouting = inject(BrowserRouting);
  private imagePreviewDialogService = inject(ImagePreviewDialogService);

  private _item: CustomRecordItem;

  @Input() set item(value: CustomRecordItem) {
    this._item = value;
    this._icon = this.initIcon();
    this._iconClass = this.initIconClass();
    this._title = this.initTitle();
  }

  private _title: string;

  get title(): string {
    return this._title;
  }

  private _icon: string;

  get icon(): string {
    return this._icon;
  }

  private _iconClass: string;

  get iconClass(): string {
    return this._iconClass;
  }

  get hasFileDownload(): boolean {
    if (!this._item) return false;

    if (!this.useImagePreviewDialog && !this.env.hasBrowser) {
      return false;
    }

    return this._item.header.images.length > 0;
  }

  get useImagePreviewDialog() {
    return this.catalogEnv.env.useLightboxForHeader;
  }

  get hasBrowserManifest() {
    return this._item && this._item.fetch && this._item.fetch.length > 0;
  }

  onShowImageDialog(evt): void {
    evt.stopPropagation();

    if (this.useImagePreviewDialog) {
      // todo: setup url for dynamic gallery

      /*const dynamicGalleryApi = this.dynamicGalleryEnv.env.apiUrl;
      const url = new URL(dynamicGalleryApi);
      url.searchParams.set('request', 'search');
      url.searchParams.set('coreId', this.coreId);

      const searchTab = this.searchQuery.getActiveTab();
      url.searchParams.set('q', this.searchQuery.getSearch(searchTab.id).search.q);
      url.searchParams.set('page', this.searchQuery.getSearch(searchTab.id).search.pageNum + '');
      url.searchParams.set('mode', 'open-layers');

      const dynamicGalleryUrl = this.dynamicGalleryRouting.defaultAbsUrl(url.toString());

      openUrl(dynamicGalleryUrl);*/

      this.imagePreviewDialogService.open({
        id: createDetailCompositeKey(this.coreId, this._item.header.id),
        label: this._item.header.label.value || this._item.header.sublabel.value,
        item: this._item
      });
      return;
    }

    if (this.hasBrowserManifest) {
      const url = this.browserRouting.galleryDefaultAbsUrl(this._item.fetch[0].url);
      openUrl(url);
    }
  }

  private initTitle(): string {
    if (this.isFtpPhoto()) {
      return 'catalog.detail.image_types.ftp_photo';
    }

    if (this.isDropbox()) {
      return 'catalog.detail.image_types.dropbox';
    }

    if (this.isArchive()) {
      return this._item.DFotoHiRes
        ? 'catalog.detail.image_types.archive_download'
        : 'catalog.detail.image_types.archive';
    }

    return 'catalog.image_preview.open_in_browser';
  }

  private initIconClass(): string {
    if (this.isFtpPhoto()) {
      return 'ftp-transfer';
    }

    if (this.isDropbox()) return 'download';

    return 'text-primary download';
  }

  private initIcon(): string {
    if (this.isFtpPhoto()) {
      return 'bolt';
    }

    if (this.isDropbox()) {
      return 'cloud_download';
    }

    if (this.isArchive()) {
      return 'cloud_download';
      //return this._item.DFotoHiRes ? fasArchive : farArchive;
    }

    return 'eyeglasses';
  }

  private isFtpPhoto(): boolean {
    return 'PathLower' in this._item && this._item['PathLower'].match(/ftp_transfer/g);
  }

  private isArchive(): boolean {
    return this._item.Source === 'AV Archiv Českého olympijského výboru';
  }

  private isDropbox(): boolean {
    return isDropbox(this._item.GulliverRecType);
  }
}
